import { Component, OnInit, Inject } from '@angular/core';
import { first } from 'rxjs/operators';
import { User } from '../_models';
import { AuthenticationService } from '../_services/authentication.service';
import { UserService } from '../_services/user.service';
import { WINDOW } from '@ng-toolkit/universal';

@Component({ templateUrl: 'home.component.html' })
export class HomeComponent implements OnInit {
    currentUser: User;
    users = [];

    tabs = [
        {
            "title": "Browse",
            "path": "categories"
        },
        {
            "title": "Search",
            "path": "search"
        }
    ];


    constructor(
        @Inject(WINDOW) private window: Window,
        private authenticationService: AuthenticationService,
        private userService: UserService
    ) {
        this.currentUser = this.authenticationService.currentUserValue;
    }

    ngOnInit() {
        //this.loadAllUsers();
    }

    deleteUser(id: number) {
        this.userService.delete(id)
            .pipe(first())
            .subscribe(() => this.loadAllUsers());
    }

    loadAllUsers() {
        this.userService.getAll()
            .pipe(first())
            .subscribe(users => this.users = users);
    }

    getPath()
    {
      return this.window.location.href.split("/").pop();
    }   

}